export default {
  everyText: 'Выберите',
  emptyMonths: 'Выберите месяц',
  emptyMonthDays: 'Выберите день месяца',
  emptyMonthDaysShort: 'Выберите день месяца',
  emptyWeekDays: 'Выберите день недели',
  emptyWeekDaysShort: 'Выберите день недели',
  emptyHours: 'Выберите час',
  emptyMinutes: 'Выберите минуту',
  emptyMinutesForHourPeriod: 'Выберите',
  yearOption: 'год',
  monthOption: 'месяц',
  weekOption: 'неделю',
  dayOption: 'день',
  hourOption: 'час',
  minuteOption: 'минута',
  rebootOption: 'перезагрузить',
  prefixPeriod: 'Каждый',
  prefixMonths: 'в',
  prefixMonthDays: 'в',
  prefixWeekDays: 'в',
  prefixWeekDaysForMonthAndYearPeriod: 'и',
  prefixHours: 'в',
  prefixMinutes: ':',
  prefixMinutesForHourPeriod: 'в',
  suffixMinutesForHourPeriod: 'минут',
  errorInvalidCron: 'Неверное значение',
  clearButtonText: 'Очистить',
  weekDays: [
    // Order is important, the index will be used as value
    'Воскресенье', // Sunday must always be first, it's "0"
    'Понедельник',
    'Вторник',
    'Среда',
    'Четверг',
    'Пятница',
    'Суббота',
  ],
  months: [
    // Order is important, the index will be used as value
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
  ],
  // Order is important, the index will be used as value
  altWeekDays: [
    'ВСК', // Sunday must always be first, it's "0"
    'ПОН',
    'ВТР',
    'СРД',
    'ЧТВ',
    'ПТН',
    'СУБ',
  ],
  // Order is important, the index will be used as value
  altMonths: ['ЯНВ', 'ФЕВ', 'МАР', 'АПР', 'МАЙ', 'ИЮН', 'ИЮЛ', 'АВГ', 'СЕН', 'ОКТ', 'НОЯ', 'ДЕК'],
};
